import React from "react";
import { Outlet } from "react-router-dom";
import Copyright from "../components/Copyright";
import Sidebar from "../components/Sidebar";
import Header from "./Header";

const TeacherLayout = () => {
  return (
    <div>
      <Header />{" "}
      <div className="flex ">
        <div>
          <Sidebar />
        </div>
        <div className="w-full h-full">
          <Outlet />
        </div>
      </div>
      <Copyright />
    </div>
  );
};

export default TeacherLayout;
